import { Font } from "@react-pdf/renderer";
import PatrickHandRegular from "./PatrickHand-Regular.ttf";
import CaveatVariable from "./Caveat-Variable.ttf";

Font.register({
  family: "patrickHandFont",
  format: "truetype",
  src: PatrickHandRegular,
});

Font.register({
  family: "caveatFont",
  format: "truetype",
  src: CaveatVariable,
});
